import { BaodoService } from 'src/services/baodo.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const BAODO_NEW_CARE_SUCCESS = 'BAODO:NEW_CARE_SUCCESS'
export const BAODO_LIST_SUCCESS = 'BAODO:FIND_ALL_SUCCESS'
export const BAODO_LIST_FAILD = 'BAODO:FIND_ALL_FAILD'
export const BAODO_COUNT_ASSIGN_SUCCESS = 'BAODO:COUNT_ASSIGN_SUCCESS'
export const BAODO_COUNT_ASSIGN_FAILD = 'BAODO:COUNT_ASSIGN_FAILD'

export const BAODO_CREATE_SUCCESS = 'BAODO:CREATE_SUCCESS'
export const BAODO_CREATE_FAILD = 'BAODO:CREATE_FAILD'

export const BAODO_IMPORT_SUCCESS = 'BAODO:IMPORT_SUCCESS'
export const BAODO_SAVE_SUCCESS = 'BAODO:SAVE_SUCCESS'
export const BAODO_SAVE_FAILD = 'BAODO:SAVE_SUCCESS'

export const BAODO_DEL_SUCCESS = 'BAODO:DEL_SUCCESS'
export const BAODO_DEL_FAILD = 'BAODO:DEL_FAILD'

export const BAODO_ONE_SUCCESS = 'BAODO:FIND_ONE_SUCCESS'
export const BAODO_ONE_FAILD = 'BAODO:FIND_ONE_FAILD'

export const BAODO_HISTORY_LIST_SUCCESS = 'BAODO:HISTORY_FIND_ALL_SUCCESS'
export const BAODO_HISTORY_LIST_FAILD = 'BAODO:HISTORY_FIND_ALL_FAILD'

export const BAODO_UPDATE_FILTER = 'BAODO:UPDATE_FILTER'

export const BaodoAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,
}

function updateFilter(payload) {
    return { type: BAODO_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            BaodoService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaodoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: BAODO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            BaodoService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaodoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: BAODO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaodoService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: BAODO_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { baodo } = getState()
        dispatch(AppAction.appLoading(true));
        BaodoService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...baodo.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAODO_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { baodo } = getState();
        const page = baodo && typeof baodo.filter !== 'undefined' && baodo.filter && typeof baodo.filter.page !== 'undefined' ? baodo.filter.page : 0;
        const limit = baodo && typeof baodo.filter !== 'undefined' && baodo.filter && typeof baodo.filter.limit !== 'undefined' ? baodo.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            BaodoService.findAll(page, limit, baodo.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = baodo.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: BAODO_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAODO_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: BAODO_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            BaodoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(BaodoAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: BAODO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            BaodoService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaodoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: BAODO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaodoService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(BaodoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaodoService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(BaodoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_DEL_SUCCESS, data } }
    function failure(error) { return { type: BAODO_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaodoService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_ONE_SUCCESS, data } }
    function failure(error) { return { type: BAODO_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaodoService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(BaodoAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { baodo } = getState()
        dispatch(AppAction.appLoading(true));
        BaodoService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...baodo.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAODO_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAODO_HISTORY_LIST_FAILD, error } }
}